// useForm.js
import { useState } from 'react';
import { _setAxios, _success } from 'lib/Helper';

const useForm = (data, fetchTable, hideModal) => {
    const [values, setValues] = useState({
        ...data,
    });
    const [loading, setLoading] = useState(false);

    const handleChangeSetValue = (name, value) => {
        setValues(prevValues => ({ ...prevValues, [name]: value }));
    };


    const handleSubmit = (val) => {

        const params = {
            nama: val?.nama,
            is_booking: values?.is_booking === "1" ? 1 : 0,
        };

        let endpoint = "jenis-ruangan";
        let method = "POST";

        if (data?.id) { 
            endpoint = `${endpoint}/${data?.id}`;
            method = "PUT";
        }

        setLoading(true);
        _setAxios(endpoint, method, params).then(resp => {
            if (resp.status) {
                _success('topRight', 'Success', resp.data.message)
                fetchTable(true);
                hideModal();
            }
            setLoading(false);
        }).catch(err => {
            setLoading(false);
        });
    };

    return {
        values,
        loading,
        handleChangeSetValue,
        handleSubmit,
    };
};

export default useForm;
